<template>
  <div
    class="project-user-list page-box"
  >
    <query-header
      ref="header"
      :selected="selected"
      @toQuery="searchHandle"
      @add="addHandle"
      @delete="deleteHandle"
    ></query-header>
    <div class="page-content">
      <div class="vs-table-outer">
        <vs-table
          multiple
          v-model="selected"
          :data="listData"
        >
          <template
            slot="thead">
            <vs-th>
              ID
            </vs-th>
            <vs-th>
              文章类型
            </vs-th>
            <vs-th>
              标题
            </vs-th>
            <vs-th>
              文章分类
            </vs-th>
            <vs-th>
              摘要
            </vs-th>
            <vs-th>
              标签
            </vs-th>
            <vs-th>
              打开次数
            </vs-th>
            <vs-th>
              操作
            </vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr
              v-for="(tr, index) in data"
              :key="index"
              :data="tr"
            >
              <vs-td>
                {{tr.id}}
              </vs-td>
              <vs-td>
                {{tr.type == 1 ?'普通文章': '帮助文章'}}
              </vs-td>
              <vs-td>
                <a
                  :href="tr.targetLink"
                  target="_blank"
                >{{tr.title}}</a>
              </vs-td>
              <vs-td>
                {{tr.category}}
              </vs-td>
              <vs-td>
                {{tr.summary || '-'}}
              </vs-td>
              <vs-td>
                {{tr.tags || '-'}}
              </vs-td>
              <vs-td>
                {{tr.openCount}}
              </vs-td>
              <vs-td>
                <el-button
                  type="text"
                  v-if="isAuth('sys:user:update')"
                  class="pointer"
                  @click.stop="editHandle(tr)"
                >修改</el-button>
                <el-button
                  type="text"
                  v-if="isAuth('sys:user:delete')"
                  class="pointer delete-btn"
                  @click="deleteHandle(tr.id)"
                >删除</el-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
      <div class="pagination-outer" v-if="total">
        <div class="paginnation-left">
          <size-change @sizeChange="sizeChange"></size-change>
          <span class="tatol-count">合计 {{total}} 条</span>
        </div>
        <vs-pagination
          class="pagination-box"
          :max="max"
          :total="pageSize"
          v-model="page"
        ></vs-pagination>
      </div>
    </div>
    <add-dialog
      :dialog-show="addDialogShow"
      @close="closeAddDialog"
      @add-success="addUserSuccess"
    ></add-dialog>
    <edit-dialog
      :row-data="currentRow"
      :dialog-show="editDialogShow"
      @close="closeEditDialog"
      @add-success="editUserSuccess"
    ></edit-dialog>
    <multiple-delete-dialog
      ref="muldelete"
      :ids="ids"
      @sure-delete="confirmDelete"
    ></multiple-delete-dialog>
  </div>
</template>

<script>
import multipleDeleteDialog from "@/components/public/multipleDeleteDialog";
import editDialog from '@/components/wx/article/editArticleDialog'
import addDialog from "@/components/wx/article/addArticleDialog";
import queryHeader from "@/components/wx/article/queryHeader";
import { mapGetters } from 'vuex'
import { colorRgba,parseTime } from '@/utils/index'
import initData from "@/mixins/initData";
import { deleteArticleManage } from "../../../api/wx/acticle";
export default {
  name: "index",
  components: {
    addDialog,
    editDialog,
    queryHeader,
    multipleDeleteDialog,
  },
  data() {
    return {
      selected: [],
      red: '#D85E5F',
      green: '#41B883',
      importShow: false,

      addDialogShow: false,
      editDialogShow: false,
      currentRow: {},
      ids: [],
    }
  },
  mixins: [initData],
  computed: {
    ...mapGetters(['themeColor','userInfo','selectedAppid']),
  },
  watch:{
    selectedAppid(val){
      if(val){
        this.searchHandle();
      }
    }
  },
  mounted(){
    this.searchHandle();
  },
  methods: {
    parseTime,
    beforeInit(){
      this.url = '/wx/manage/article/list';
      this.params = {
        page: this.page,
        limit: this.size,
        'sidx': 'id',
        'order': 'desc'
      }
      let header = this.$refs.header;
      if(header.type){
        this.params.type = header.type;
      }
      if(header.category){
        this.params.category = header.category;
      }
      if(header.name){
        this.params.title = header.name;
      }
      return true;
    },

    addHandle(){
      setTimeout(() => {
        this.addDialogShow = true;
      },200);
    },
    addUserSuccess(){
      this.addDialogShow = false;
      this.searchHandle();
    },
    editHandle(row){
      this.currentRow = row;
      setTimeout(() => {
        this.editDialogShow = true;
      },200);
    },
    editUserSuccess(){
      this.editDialogShow = false;
      this.searchHandle();
    },
    closeEditDialog(){
      this.editDialogShow = false;
    },
    deleteHandle(id){
      this.ids = id ? [id] : this.selected.map(item => item.id);
      this.$refs.muldelete.dialogShow = true;
    },
    confirmDelete(ids){
      deleteArticleManage(ids).then((res) => {
        this.$message({
          type: 'success',
          message: '已删除'
        });
        this.$refs.muldelete.dialogShow = false;
        this.searchHandle();
      })
    },
    closeAddDialog(){
      this.addDialogShow = false;
    },
    getStatus(tr){
      if(tr.status === 0){
        return '禁用';
      }else {
        return '正常';
      }
    },
    getStyle(tr){
      if(tr.status === 0){
        return {
          backgroundColor: colorRgba(this.red ,0.1),
          color: this.red,
        };
      }else {

        return {
          backgroundColor: colorRgba(this.green,0.1),
          color: this.green,
        };
      }
    },
    searchHandle(){
      this.page = 1;
      this.init();
    },
  },
}
</script>

<style lang="scss" scoped>
.project-user-list {
  .box-item {
    margin-bottom: 10px;
  }
  .btn {
    margin-right: 10px;
  }
  .vs-table-outer {
    .vs-con-table {
      min-width: 1200px;
    }
  }
  .tag-box {
    padding: 5px 10px;
    border-radius: 15px;
  }
  .reject-reason {
    max-width: 120px;
  }
}
</style>
